import api from '@/services/Api';

class EstimateRepairerService {

  async backToRepairerOffersCreation(repair_file_id) {
    const data = {
      repair_file_id: repair_file_id,
    }
    const response = await api.put(
      '/distributor/repair-file/repairer-estimate/back-to-creation',
      data)
    return response.data
  }
}

export default new EstimateRepairerService()
